import { QAlert } from "../CoreApp/QAlert";
import { appstr } from "./appstr";
import { appstrp } from "./appstrp";

export const INVALID_FILENAME_CHARS_REGEX = /^[^\\/:.\*\?"<>\|]+$/;

export const MIN_NAME_LENGTH = 2;

export const enumNameValidation = {
  valid: "valid",
  tooShort: "tooShort",
  invalidChars: "invalidChars"
};

export function GetNameValidation(name) {
  if (!name || name.length < MIN_NAME_LENGTH) return enumNameValidation.tooShort;
  if (!INVALID_FILENAME_CHARS_REGEX.test(name)) return enumNameValidation.invalidChars;
  return enumNameValidation.valid;
}

export function GetNameValidationMessage(reason) {
  if (reason === enumNameValidation.tooShort) {
    return appstr("Minimum length is 2 characters");
  }
  return appstrp("A file name can't contain", '\\ / : * ? " < > | .');
}

export function ShowInvalidNameAlert(wsMgr, reason) {
  var alert = new QAlert();
  var message = GetNameValidationMessage(reason);
  alert.InitAlert(appstr("Invalid File Name"), message, null, wsMgr);
}

export function ValidateRename(name, wsMgr) {
  var reason = GetNameValidation(name);
  if (reason !== enumNameValidation.valid) {
    var message = GetNameValidationMessage(reason);
    ShowInvalidNameAlert(wsMgr, reason);
    return { valid: false, message };
  }
  return { valid: true, message: "" };
}
